import Drawable from '../entities/Drawable.js';
import { c } from '../setup.js';


export default class DarkScreen extends Drawable {
    constructor() {
        super();
        this.visible = true;
        this.alpha = 0;
    }
    draw() {
        if (!this.visible) {
            return;
        }
        c.fillStyle = `rgba(0, 0, 0, ${this.alpha})`;
        c.fillRect(0, 0, 240, 160);
    }
}
